import type { MultipleBetType, SgmData } from '@ps/isp-web-services-types';
import { Translation } from '@ps/web-shared-components';
import classNames from 'clsx';
import React from 'react';

import { SgmEventAndLegCount } from '@swf/layouts/SportsLayout/components/BetSlip/components/SgmEventAndLegCount/SgmEventAndLegCount';
import { Icon } from '@swf/sports/components';
import { BetPriceOdds } from '@swf/sports/components/BetPriceOdds/BetPriceOdds';
import type { BetPriceOdds as BetPrice } from '@swf/sports/types/odds';
import { getMultipleName } from '@swf/sports/utils/getMultipleName';

import { TXTWCL_EW } from './Title.messages.json';
import styles from './Title.scss';

interface Props {
  type?: MultipleBetType;
  numberOfLines: number;
  betPrice?: BetPrice;
  isEachWaySelected?: boolean;
  isSgm?: boolean;
  isOpen?: boolean;
  sgmData?: SgmData[];
}

const Title: React.FC<Props> = ({
  type,
  numberOfLines,
  betPrice,
  isSgm,
  isEachWaySelected,
  isOpen = false,
  sgmData
}) => (
  <div className={classNames(styles.wrapper, { [styles.open]: isOpen })}>
    <h3 className={styles.title}>
      <div className={classNames({ [styles.iconWrapper]: isSgm })}>
        <Icon name={isSgm ? 'bet-builder' : 'multiples'} size="xl" />
      </div>
      <div>
        {getMultipleName({
          betType: type,
          numberOfLines,
          isSgm
        })}{' '}
        {numberOfLines === 1 && betPrice ? (
          <>
            @ <BetPriceOdds {...betPrice} />
          </>
        ) : null}
        {isEachWaySelected ? (
          <>
            {' '}
            <Translation {...TXTWCL_EW} />{' '}
          </>
        ) : null}
        {isSgm && sgmData && <SgmEventAndLegCount sgmData={sgmData} />}
      </div>
    </h3>

    <Icon
      name="chevron-medium-down"
      className={classNames(styles.icon, { [styles.iconOpen]: isOpen })}
      size="lg"
    />
  </div>
);

export default Title;
